import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { SECTION_DEFAULTS, LINKS, LOGO } from "../data/content";

const hexToChannels = (hex) => {
  if (!hex) return null;
  const m = hex.replace("#", "");
  const full = m.length === 3 ? m.split("").map((c) => c + c).join("") : m;
  const int = parseInt(full, 16);
  if (Number.isNaN(int)) return null;
  return `${(int >> 16) & 255} ${(int >> 8) & 255} ${int & 255}`;
};

const applyColors = (colors) => {
  if (!colors) return;
  const p = hexToChannels(colors.primary);
  const a = hexToChannels(colors.accent);
  if (p) document.documentElement.style.setProperty("--brand-teal", p);
  if (a) document.documentElement.style.setProperty("--brand-accent", a);
};

const SiteConfigContext = createContext({ images: {}, colors: {}, img: (k, f) => f, refresh: () => {} });

export const SiteConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({ images: {}, colors: {} });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/site-config");
      setConfig(data);
      applyColors(data.colors);
    } catch { /* keep defaults */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const img = useCallback(
    (key, fallback) => config.images?.[key] || SECTION_DEFAULTS[key] || fallback,
    [config]
  );

  const link = useCallback(
    (key) => config.links?.[key] || LINKS[key],
    [config]
  );
  const logo = config.logo || LOGO;
  const footerTagline = config.footer_tagline || "A whitelisted RedM roleplay frontier. Ride in, become someone, and leave your mark under the aurora.";

  return (
    <SiteConfigContext.Provider value={{ ...config, img, link, logo, footerTagline, refresh }}>
      {children}
    </SiteConfigContext.Provider>
  );
};

export const useSiteConfig = () => useContext(SiteConfigContext);
